<script>
import { podeSelecionarFormaPagamento } from '@/libs/perfilCliente';
import CardItemNew from '@/views/app/CartECommerce/carrinho-compra/CardItemNew.vue';
import { precoVisualizacao, ehValorDeCusto } from '@/utils/precoVisualizacao';
import { mapGetters } from 'vuex';
import { formtPriceBr } from '@core/utils/filter';
import { generateRandomNumberOrder } from '@core/utils/utils';
import { BFormGroup, BOverlay, BBadge, BFormCheckbox } from 'bootstrap-vue';
import PedidoService from '@/services/Operacoes/SLSPedidos.service';
import Swal from 'sweetalert2';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import { getParametro } from '@/utils/totvsApi';
import { enderecoEntregaValido, simularPrecoAtualCarrinho, aplicarPrecoAtualCarrinho } from '@/utils/impostoSimulador';
import ModalBuscarCondPagamento from '@/components/modal/ModalBuscarCondPagamento.vue';
import ModalAutoCompletarPedido from '@/components/modal/ModalAutoCompletarPedido.vue';
import EscolherEnderecoEntrega from '@/components/pedidos/EscolherEnderecoEntrega.vue';
import SelectTransporte from '@/components/pedidos/SelectTransporte.vue';
import PagamentoAVistaVisual from '@/components/pedidos/PagamentoAVistaVisual.vue';
import InitialDataService from '@/services/InitialData.service';
import BudgetClient from '@/api/Budget/budget.client';
import { itensBudgetCarrinho } from '@/utils/budgetCarrinhoItens';
import {
  nomeCategoria, ocultarInfoComercialCliente, ocultarTabelaCondicaoRepresentante, ocultarTabelaCondicaoSupervisor, isPedidoDoacao, isPerfilClienteAtivo,
} from '@/libs/perfilCliente';

const pedidoService = new PedidoService();
const budgetClient = new BudgetClient();
export default {
  name: 'Index',
  components: {
    BOverlay, BFormGroup, BBadge, BFormCheckbox, CardItemNew, ModalBuscarCondPagamento, ModalAutoCompletarPedido, EscolherEnderecoEntrega, SelectTransporte, PagamentoAVistaVisual,
  },
  data() {
    return {
      loading: false,
      todayISO: new Date().toISOString().split('T')[0],
      // ID Nexus opcional e exclusivo de doação (WD).
      idNexusCart: '',
      // Pré-checagem de budget (doação WD) por categoria ELT/GL.
      budgetCarrinho: null,
      budgetCheckTimer: null,
      budgetCheckSeq: 0,
      // Endereço de entrega alternativo escolhido no fechamento (ou null = padrão).
      enderecoAlternativo: null,
      transporteId: null,
      // Opção visual local da finalização; não integra pedido, rascunho ou store.
      boletoPara15Dias: false,
      pagamentoAVistaSelecionado: false,
    };
  },
  watch: {
    // Reavalia o budget conforme itens mudam (aviso antecipado de estouro).
    pedidoItens: {
      deep: true,
      handler() { this.agendarChecagemBudget(); },
    },
    representanteBudgetId() { this.agendarChecagemBudget(); },
    // Endereço alternativo escolhido no InfoPedido (fluxo obrigatório para
    // cliente sem endereço) → chega ao carrinho via Vuex.
    enderecoAlternativoStore: {
      immediate: true,
      handler(val) {
        if (!this.isPedidoDoacaoAtual) {
          if (val || this.enderecoAlternativo) this.restaurarEnderecoPadrao();
          return;
        }
        if (val && !this.enderecoAlternativo) this.enderecoAlternativo = val;
      },
    },
    // E o escolhido aqui no carrinho volta ao Vuex (fonte única).
    enderecoAlternativo(val) {
      this.$store.commit('InfoPedido/SET_ENDERECO_ALTERNATIVO', val || null);
    },
    isPedidoDoacaoAtual(isDoacao) {
      this.agendarChecagemBudget();
      if (isDoacao) {
        this.boletoPara15Dias = false;
        this.pagamentoAVistaSelecionado = false;
      }
      if (!isDoacao) this.restaurarEnderecoPadrao();
    },
  },
  filters: {
    formtPriceBr,
  },
  computed: {
    totalVisual() {
      let total = 0;
      const tipo = this.formInfoPedido?.tipoPedidoCliente?.tipopedidoid
        || this.formInfoPedido?.tipoPedido?.tipopedidoid;
      for (const item of this.items) {
        const preco = precoVisualizacao({ item, tipoPedido: item.categoria_tipo_pedido || tipo });
        if (preco === null) return null;
        total += preco * Number(item.pedido_item_quantidade);
      }
      return total;
    },
    totalDeCustoVisual() {
      return this.items.some(item => ehValorDeCusto(item.categoria_tipo_pedido
        || this.formInfoPedido?.tipoPedidoCliente?.tipopedidoid
        || this.formInfoPedido?.tipoPedido?.tipopedidoid));
    },
    enderecoAlternativoStore() {
      return this.$store.getters['InfoPedido/GET_ENDERECO_ALTERNATIVO'];
    },
    ...mapGetters('PedidosStore', {
      items: 'getItemPedido',
      getTotalItensPedido: 'getTotalItensPedido',
    }),
    ...mapGetters('InfoPedido', [
      'GET_CLIENTE_DATA',
    ]),
    ...mapGetters('PicStore', {
      picSelected: 'GET_PIC_SELECTED',
    }),
    // Botão "Salvar Como Rascunho": preferência ativa + perfil autorizado e,
    // quando restrito a doação, apenas em pedidos WD.
    rascunhoDisponivel() {
      if (!this.$store.getters['preferencias/rascunhoPermitido']) return false;
      if (this.$store.getters['preferencias/rascunhoApenasDoacao'] && !this.isPedidoDoacaoAtual) return false;
      return true;
    },
    // Pedido de doação (WD): não há valor mínimo — nem aviso, nem bloqueio.
    isPedidoDoacaoAtual() {
      const tipo = this.formInfoPedido?.tipoPedidoCliente?.tipopedidoid
        || this.formInfoPedido?.tipoPedido?.tipopedidoid;
      return isPedidoDoacao(tipo);
    },
    representanteBudgetId() {
      return this.formInfoPedido?.representante?.representanteid;
    },
    isPedidoCertificacaoAtual() {
      const tipo = this.formInfoPedido?.tipoPedidoCliente?.tipopedidoid
        || this.formInfoPedido?.tipoPedido?.tipopedidoid;
      return String(tipo || '').trim().toUpperCase() === 'WC';
    },
    pedidoMinimo() {
      if (this.isPedidoDoacaoAtual || this.isPedidoCertificacaoAtual) return true;
      return this.$store.getters['PedidosStore/getTotalPedidoComImposto'] >= Number((this.GET_CLIENTE_DATA || {}).valorMinimoPedido || 0);
    },
    // Preferência BLOQUEAR_PEDIDO_MINIMO: quando ativa (padrão), pedidos abaixo
    // do mínimo são bloqueados; quando inativa, apenas avisamos na finalização.
    bloqueioPedidoMinimoAtivo() {
      return this.$store.getters['preferencias/bloquearPedidoMinimo'];
    },
    // Preferência CLIENTE_OCULTAR_INFO_COMERCIAL: esconde (só visualmente) a
    // condição de pagamento no resumo do pedido p/ perfil Cliente.
    ocultarInfoComercial() {
      return ocultarInfoComercialCliente(this.$store);
    },
    // Preferência REPRESENTANTE_OCULTAR_INFO_COMERCIAL: esconde (só visualmente)
    // a condição de pagamento p/ perfil Representante (além do gate do Cliente).
    ocultarTabelaCondicao() {
      return this.ocultarInfoComercial || ocultarTabelaCondicaoRepresentante(this.$store) || ocultarTabelaCondicaoSupervisor(this.$store);
    },
    isPerfilCliente() {
      return isPerfilClienteAtivo();
    },
    exibirBoletoPara15Dias() {
      return !this.isPedidoDoacaoAtual && podeSelecionarFormaPagamento();
    },
    formInfoPedido: {
      get() {
        return this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];
      },
      set(value) {
        this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', value);
      },
    },
    pedido: {
      get() {
        return this.$store.getters['PedidosStore/getPedido'];
      },
      set(value) {
        this.$store.commit('PedidosStore/SET_PEDIDO', value);
      },
    },
    pedidoItens: {
      get() {
        return this.$store.getters['PedidosStore/getItemPedido'];
      },
      set(value) {
        this.$store.commit('PedidosStore/SET_CART_ITEMS', value);
      },
    },
    dataEntregaPadrao() {
      const date = new Date();
      date.setDate(date.getDate() + 7);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const br = `${day}/${month}/${year}`;
      console.debug('[Cart] dataEntregaPadrao computed ->', { base: new Date().toISOString(), plus7ISO: date.toISOString().split('T')[0], br });
      return br;
    },
    avisosBudgetCarrinho() {
      const cats = (this.budgetCarrinho && this.budgetCarrinho.categorias) || {};
      return Object.values(cats).map(c => c && c.mensagem).filter(Boolean);
    },
    budgetCarrinhoBloqueia() {
      const cats = (this.budgetCarrinho && this.budgetCarrinho.categorias) || {};
      return Object.values(cats).some(c => c && c.bloqueia);
    },
    budgetMisto() {
      return !!(this.budgetCarrinho && this.budgetCarrinho.misto);
    },
    dataEntregaInput: {
      get() {
        const current = this.formInfoPedido?.dataPrevistaEntrega || this.dataEntregaPadrao;
        const iso = this.normalizeDateToISO(current);
        console.debug('[Cart] dataEntregaInput.get', { current, iso });
        return iso;
      },
      set(newISO) {
        if (!newISO) return;
        const todayISO = new Date().toISOString().split('T')[0];
        let isoToCommit = newISO.split('T')[0];
        if (isoToCommit < todayISO) {
          const d = new Date();
          d.setDate(d.getDate() + 7);
          isoToCommit = d.toISOString().split('T')[0];
          console.debug('[Cart] dataEntregaInput.set: past date detected, overriding to +7', { from: newISO, to: isoToCommit });
        }
        const [yyyy, mm, dd] = isoToCommit.split('-');
        const br = `${dd}/${mm}/${yyyy}`;
        console.debug('[Cart] dataEntregaInput.set', { newISO, commitISO: isoToCommit, commitBR: br });
        this.$store.commit('InfoPedido/SET_DATA_PREVISTA_ENTREGA', br);
      },
    },
  },
  methods: {
    async recuperarPrecosTabelaCarrinho() {
      const form = this.formInfoPedido;
      const itens = this.pedidoItens;
      const tipo = String(form?.tipoPedidoCliente?.tipopedidoid || form?.tipoPedido?.tipopedidoid || '').toUpperCase();
      const pendentes = itens.filter(i => !Number.isFinite(Number(i.pedido_item_preco_tabela_erp))
        || Number(i.pedido_item_preco_tabela_erp) <= 0);
      if (!pendentes.length) return;
      const contexto = JSON.stringify(form);
      const assinatura = JSON.stringify(itens);
      const atualizados = await Promise.all(itens.map(async (item) => {
        if (!pendentes.includes(item)) return item;
        if (item.item_pic_promocao) {
          throw new Error(`O item promocional ${item.item_id} não possui preço ERP de tabela confirmado. Atualize sua quantidade para recalcular a promoção antes de finalizar.`);
        }
        const calculo = await simularPrecoAtualCarrinho(form, item.item_id);
        return aplicarPrecoAtualCarrinho({ ...item, categoria_tipo_pedido: tipo }, calculo);
      }));
      if (JSON.stringify(this.formInfoPedido) !== contexto || JSON.stringify(this.pedidoItens) !== assinatura) {
        throw new Error('Cliente, tabela, quantidade ou itens mudaram durante o cálculo. Confira o carrinho e tente novamente.');
      }
      this.$store.commit('PedidosStore/SET_PEDIDO', {
        ...this.pedido,
        pedidoItens: atualizados,
      });
    },
    // Campos do endereço de entrega alternativo p/ o payload (vazio = padrão).
    camposEnderecoEntrega() {
      const e = this.enderecoAlternativo;
      const transporte = this.isPedidoDoacaoAtual && this.transporteId
        ? { transportadoraid: String(this.transporteId) }
        : {};
      if (!this.isPedidoDoacaoAtual || !e) return transporte;
      return {
        ...transporte,
        pedidoentregaendereco: e.endereco,
        pedidoentreganumero: e.numero,
        pedidoentregacomplemento: e.complemento,
        pedidoentregabairro: e.bairro,
        pedidoentregacidade: e.cidade,
        pedidoentregauf: e.uf,
        pedidoentregacep: e.cep,
      };
    },
    restaurarEnderecoPadrao() {
      this.enderecoAlternativo = null;
      this.$store.commit('InfoPedido/SET_ENDERECO_ALTERNATIVO', null);
    },
    resetBoletoPara15Dias() {
      this.boletoPara15Dias = false;
      this.pagamentoAVistaSelecionado = false;
      if (this.$refs.pagamentoAVistaVisual) this.$refs.pagamentoAVistaVisual.reset();
    },
    // ── Pré-checagem de budget (doação WD) por categoria ELT/GL ──
    agendarChecagemBudget() {
      this.budgetCheckSeq += 1;
      this.budgetCarrinho = null;
      if (this.budgetCheckTimer) clearTimeout(this.budgetCheckTimer);
      this.budgetCheckTimer = null;
      if (!this.isPedidoDoacaoAtual || !this.representanteBudgetId
        || !itensBudgetCarrinho(this.pedidoItens).length) return;
      this.budgetCheckTimer = setTimeout(() => this.verificarBudgetCarrinho(), 600);
    },
    // Monta o payload e envia o pedido do carrinho (usado também no reenvio
    // com confirmação de divisão por categoria ELT/GL).
    async enviarPedidoCart({ naturezaOperacaoImposto, dataEntregaISO, confirmarDivisaoCategorias }) {
      return pedidoService.finalizarPedidoCart({
        picid: this.picSelected?.picid || null,
        estabelecimentoid: this.formInfoPedido.estabelecimento.estabelecimentoid,
        representanteid: this.formInfoPedido.representante.representanteid,
        clienteid: this.formInfoPedido.cliente.clienteid,
        tipopedidoid: this.formInfoPedido.tipoPedidoCliente?.tipopedidoid || this.formInfoPedido.tipoPedido?.tipopedidoid || '',
        condicaopagamentoid: this.formInfoPedido.condicaoPagamento.condicaopagamentoid,
        tabelaprecoid: this.formInfoPedido.tabelaPreco.tabelapreco_id,
        pedidoobservacoes: this.formInfoPedido.observacao,
        pedidourgente: false,
        pedidodataentrega: dataEntregaISO,
        pedidodataentregaprevista: dataEntregaISO,
        pedidovalortotal: this.$store.getters['PedidosStore/getTotalPedido'],
        tipoenderecoid: (this.formInfoPedido.enderecoEntrega && this.formInfoPedido.enderecoEntrega.tipoenderecoid) || null,
        pedidooccliente: this.formInfoPedido.numeroPedidoOrderCompra,
        pedidoconsumidorfinal: true,
        pedidoprioridade: this.formInfoPedido.prioridadesPedido,
        canalvendaid: this.formInfoPedido.canalVenda?.canal_venda_id || '',
        cod_priori: this.formInfoPedido.prioridadesPedido,
        naturezaoperacaoid: naturezaOperacaoImposto,
        itemsPedido: this.pedidoItens,
        confirmarDivisaoCategorias: !!confirmarDivisaoCategorias,
        idnexus: this.idNexusCart || this.formInfoPedido.idNexus || '',
        ...this.camposEnderecoEntrega(),
      });
    },
    // ID Nexus é opcional e exclusivo de doação (WD), independentemente do perfil.
    async garantirIdNexusCart() {
      if (!this.isPedidoDoacaoAtual) return true;
      const atual = String(this.idNexusCart || this.formInfoPedido.idNexus || '').trim();
      if (!atual) return true;
      if (/^\d{6}$/.test(atual)) { this.idNexusCart = atual; return true; }
      await Swal.fire({
        title: 'ID Nexus inválido',
        text: 'Se informar o ID Nexus, use exatamente 6 dígitos numéricos.',
        icon: 'warning',
        confirmButtonText: 'Entendi',
      });
      return false;
    },
    async verificarBudgetCarrinho() {
      this.budgetCheckTimer = null;
      const seq = ++this.budgetCheckSeq;
      this.budgetCarrinho = null;
      if (!this.isPedidoDoacaoAtual) return;
      const representanteid = this.representanteBudgetId;
      const itens = itensBudgetCarrinho(this.pedidoItens);
      if (!representanteid || !itens.length) return;
      try {
        const { data: res } = await budgetClient.validarCarrinho({ representanteid, itens });
        if (seq !== this.budgetCheckSeq) return; // resposta antiga: descarta
        this.budgetCarrinho = res && res.data;
      } catch (e) {
        if (seq === this.budgetCheckSeq) this.budgetCarrinho = null; // best-effort
      }
    },
    abrirAutoCompletar() {
      if (this.$refs.modalAutoCompletar) {
        this.$refs.modalAutoCompletar.open();
      }
    },
    ensureValidEntregaDateBR() {
      try {
        const currentBR = this.formInfoPedido?.dataPrevistaEntrega;
        const currentISO = this.normalizeDateToISO(currentBR);
        const todayISO = new Date().toISOString().split('T')[0];
        if (!currentISO || currentISO < todayISO) {
          const d = new Date();
          d.setDate(d.getDate() + 7);
          const iso = d.toISOString().split('T')[0];
          const [yyyy, mm, dd] = iso.split('-');
          const br = `${dd}/${mm}/${yyyy}`;
          console.debug('[Cart] ensureValidEntregaDateBR: fixing past/empty date', {
            prevBR: currentBR, prevISO: currentISO, commitISO: iso, commitBR: br,
          });
          this.$store.commit('InfoPedido/SET_DATA_PREVISTA_ENTREGA', br);
        } else {
          console.debug('[Cart] ensureValidEntregaDateBR: date OK', { currentISO });
        }
      } catch (e) {
        console.debug('[Cart] ensureValidEntregaDateBR: error', e);
      }
    },
    normalizeDateToISO(dateValue) {
      const todayISO = new Date().toISOString().split('T')[0];
      console.debug('[Cart] normalizeDateToISO: input', dateValue, 'todayISO', todayISO);
      if (!dateValue) {
        const d = new Date();
        d.setDate(d.getDate() + 7);
        const out = d.toISOString().split('T')[0];
        console.debug('[Cart] normalizeDateToISO: no input, returning', out);
        return out;
      }

      if (typeof dateValue === 'string') {
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateValue)) {
          const [dd, mm, yyyy] = dateValue.split('/');
          const out = `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
          console.debug('[Cart] normalizeDateToISO: BR->ISO', { in: dateValue, out });
          return out;
        }
        if (/^\d{4}-\d{2}-\d{2}/.test(dateValue)) {
          const out = dateValue.split('T')[0];
          console.debug('[Cart] normalizeDateToISO: ISO passthrough', { in: dateValue, out });
          return out;
        }
      }

      try {
        const d = new Date(dateValue);
        if (!isNaN(d.getTime())) {
          const out = d.toISOString().split('T')[0];
          console.debug('[Cart] normalizeDateToISO: Date parsed', { in: dateValue, out });
          return out;
        }
      } catch (e) { /* noop */ }

      const d = new Date();
      d.setDate(d.getDate() + 7);
      const out = d.toISOString().split('T')[0];
      console.debug('[Cart] normalizeDateToISO: fallback', out);
      return out;
    },
    getActiveDraftId() {
      try {
        return localStorage.getItem('activeDraftId') || null;
      } catch (e) {
        return null;
      }
    },
    setActiveDraftId(id) {
      try {
        if (id) localStorage.setItem('activeDraftId', String(id));
      } catch (e) { /* noop */ }
    },
    updateDraftsIndex(meta) {
      try {
        const key = 'pedido_drafts_index';
        const raw = localStorage.getItem(key);
        const index = raw ? JSON.parse(raw) : [];
        const i = index.findIndex((d) => String(d.id) === String(meta.id));
        if (i >= 0) index[i] = { ...index[i], ...meta, updatedAt: new Date().toISOString() };
        else index.push({ ...meta, createdAt: new Date().toISOString(), updatedAt: new Date().toISOString() });
        localStorage.setItem(key, JSON.stringify(index));
      } catch (e) { /* noop */ }
    },
    removeDraftCompletely(draftId) {
      try {
        if (!draftId) return;
        localStorage.removeItem(`pedido_draft_${draftId}`);
        const key = 'pedido_drafts_index';
        const raw = localStorage.getItem(key);
        const index = raw ? JSON.parse(raw) : [];
        const filtered = index.filter((d) => String(d.id) !== String(draftId));
        localStorage.setItem(key, JSON.stringify(filtered));
        const active = this.getActiveDraftId();
        if (active && String(active) === String(draftId)) {
          localStorage.removeItem('activeDraftId');
        }
      } catch (e) { /* noop */ }
    },
    saveDraftSnapshot(draftId) {
      try {
        if (!draftId) return;
        const snapshot = {
          id: draftId,
          origem: 'carrinho',
          infoPedidoSnapshot: this.formInfoPedido,
          itens: this.pedidoItens,
          total: this.$store.getters['PedidosStore/getTotalPedido'],
        };
        localStorage.setItem(`pedido_draft_${draftId}`, JSON.stringify(snapshot));

        const clienteNome = this.formInfoPedido?.cliente?.clientenomeabreviado || this.GET_CLIENTE_DATA?.cliente?.clientenomeabreviado || '';
        const meta = {
          id: draftId,
          cliente: clienteNome,
          origem: 'carrinho',
          total: snapshot.total,
        };
        this.updateDraftsIndex(meta);
        this.setActiveDraftId(draftId);
      } catch (e) { /* noop */ }
    },
    loadActiveDraftIfAny() {
      try {
        const activeId = this.getActiveDraftId();
        if (!activeId) return;
        if (this.pedidoItens && this.pedidoItens.length > 0) return;
        const raw = localStorage.getItem(`pedido_draft_${activeId}`);
        if (!raw) {
          console.log('Rascunho não encontrado neste dispositivo. O rascunho ativo foi iniciado em outro dispositivo. Prosseguindo sem restauração.');
          return;
        }
        const draft = JSON.parse(raw);
        if (draft.infoPedidoSnapshot) {
          this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', draft.infoPedidoSnapshot);
          this.$root.$emit('info-pedido:updated', draft.infoPedidoSnapshot);
          this.ensureValidEntregaDateBR();
        }
        if (Array.isArray(draft.itens)) {
          this.$store.commit('PedidosStore/SET_CART_ITEMS', draft.itens);
        }
      } catch (e) { /* noop */ }
    },
    onlyNumber(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    },
    onChangeCondPagto() {
      const codigo = String(this.formInfoPedido.condicaoPagamento?.condicaopagamentoid || '').trim();
      if (!codigo) {
        this.$store.commit('InfoPedido/SET_CONDICAO_PAGAMENTO_FORM', {
          condicaopagamentoid: null,
          condicaopagamentodescricao: null,
        });
        return;
      }
      const options = this.$store.getters['InfoPedido/GET_OPTIONS_CONDICAO_PAGAMENTO'] || [];
      const match = options.find((o) => String(o.condicaopagamentoid) === codigo);
      if (match) {
        this.$store.commit('InfoPedido/SET_CONDICAO_PAGAMENTO_FORM', {
          condicaopagamentoid: match.condicaopagamentoid,
          condicaopagamentodescricao: match.condicaopagamentodescricao,
        });
      }
    },
    onInputTipoPedidoCliente(value) {
      console.log('onInputTipoPedidoCliente', value);
      this.pedido.tipoPedidoCliente = value;
    },
    async finalizarRascunhoCart() {
      this.loading = true;
      try {
        await this.recuperarPrecosTabelaCarrinho();
        const naturezaOperacaoImposto = this.pedidoItens.length > 0 && this.pedidoItens[0].naturezaoperacaoidimposto
          ? this.pedidoItens[0].naturezaoperacaoidimposto
          : this.formInfoPedido.naturezaOperacao?.naturezaoperacaoid || '';

        const dataEntregaISO = this.normalizeDateToISO(this.formInfoPedido.dataPrevistaEntrega || this.dataEntregaPadrao);

        const resPedido = await pedidoService.finalizarRascunhoCart({
          picid: this.picSelected?.picid || null,
          estabelecimentoid: this.formInfoPedido.estabelecimento.estabelecimentoid,
          representanteid: this.formInfoPedido.representante.representanteid,
          clienteid: this.formInfoPedido.cliente.clienteid,
          tipopedidoid: this.formInfoPedido.tipoPedidoCliente?.tipopedidoid || this.formInfoPedido.tipoPedido?.tipopedidoid || '',
          condicaopagamentoid: this.formInfoPedido.condicaoPagamento.condicaopagamentoid,
          tabelaprecoid: this.formInfoPedido.tabelaPreco.tabelapreco_id,
          pedidoobservacoes: this.formInfoPedido.observacao,
          pedidourgente: false,
          pedidodataentrega: dataEntregaISO,
          pedidodataentregaprevista: dataEntregaISO,
          pedidovalortotal: this.$store.getters['PedidosStore/getTotalPedido'],
          tipoenderecoid: (this.formInfoPedido.enderecoEntrega && this.formInfoPedido.enderecoEntrega.tipoenderecoid) || null,
          pedidooccliente: this.formInfoPedido.numeroPedidoOrderCompra,
          pedidoconsumidorfinal: true,
          pedidoprioridade: this.formInfoPedido.prioridadesPedido,
          canalvendaid: this.formInfoPedido.canalVenda?.canal_venda_id || '',
          cod_priori: this.formInfoPedido.prioridadesPedido,
          naturezaoperacaoid: naturezaOperacaoImposto,
          itemsPedido: this.pedidoItens,
          ...this.camposEnderecoEntrega(),
        });

        // Salva snapshot local por rascunho e marca como ativo
        const draftId = resPedido?.data?.data?.pedidoid;
        if (draftId) {
          this.saveDraftSnapshot(draftId);
        }

        // Aviso: integração com TOTVS pausada para testes
        const totvsFlag = await getParametro('INTEGRACAO_TOTVS');
        if (String(totvsFlag) === '0' && this.$toast) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Aviso',
              text: 'A integração com o TOTVS está pausada para período de testes.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
        }

        Swal.fire({
          title: 'Rascunho Salvo com Sucesso!',
          html: `Seu rascunho foi salvo com sucesso! Número do Rascunho: <strong>#${resPedido.data.data.pedidoid}</strong>`,
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          this.resetBoletoPara15Dias();
          this.$store.dispatch('PedidosStore/clearPedidoAndItemPedido');
          this.$router.push({ name: 'home' });
        });
      } catch (error) {
        console.error('Erro ao finalizar pedido:', error);

        const errorMessage = error.message;

        if (errorMessage === 'ERRO_PEDIDO_NR_OC_CLIENTE_EXISTE') {
          Swal.fire({
            title: 'Erro ao finalizar pedido',
            text: 'O número da ordem de compra já existe. Por favor, utilize um número diferente.',
            icon: 'warning',
            confirmButtonText: 'OK',
          });
          return;
        }
        // Mensagem clara vinda do backend (ex.: verba/budget insuficiente do
        // representante, ou perfil sem permissão para o tipo de pedido — 403).
        // O client de pedidos usa messageCustom, que extrai a mensagem do
        // backend para error.message (sem manter error.response). Também
        // cobrimos error.response.data.message para chamadas que repassam o erro cru.
        const backendMessage = error?.response?.data?.message || error?.message;
        if (backendMessage) {
          Swal.fire({
            title: (error && error.title) || 'Não foi possível finalizar o pedido',
            text: backendMessage,
            icon: 'warning',
            confirmButtonText: 'OK',
          });
          return;
        }
        Swal.fire({
          title: 'Erro ao finalizar pedido',
          text: 'Ocorreu um erro ao processar seu pedido. Por favor, tente novamente mais tarde.',
          icon: 'warning',
          confirmButtonText: 'OK',
        });
      } finally {
        this.loading = false;
      }
    },
    async finalizarPedidoCart() {
      // Endereço obrigatório: ou o cadastro do cliente tem UF+cidade, ou foi
      // escolhido um endereço alternativo no campo "Endereço de Entrega".
      const altValido = this.isPedidoDoacaoAtual
        && this.enderecoAlternativo
        && String(this.enderecoAlternativo.uf || '').trim()
        && String(this.enderecoAlternativo.cidade || '').trim();
      if (!altValido && !enderecoEntregaValido(this.formInfoPedido.enderecoEntrega)) {
        Swal.fire({
          title: 'Endereço de entrega obrigatório',
          text: 'Este cliente não tem endereço completo cadastrado. Selecione ou cadastre um endereço no campo "Endereço de Entrega" antes de finalizar o pedido.',
          icon: 'warning',
          confirmButtonText: 'Entendi',
          customClass: { confirmButton: 'btn btn-warning' },
          buttonsStyling: false,
        });
        return;
      }
      // Garante que as preferências estejam carregadas antes de decidir entre
      // bloquear e avisar (evita corrida com o load fire-and-forget do mounted).
      if (!this.$store.getters['preferencias/loaded']) {
        await this.$store.dispatch('preferencias/load').catch(() => {});
      }

      // Pedido mínimo em modo AVISO (preferência BLOQUEAR_PEDIDO_MINIMO desativada):
      // permite finalizar abaixo do mínimo, mas pede confirmação explícita.
      if (!this.pedidoMinimo && !this.bloqueioPedidoMinimoAtivo) {
        const minimo = Number((this.GET_CLIENTE_DATA || {}).valorMinimoPedido || 0);
        const confirmacao = await Swal.fire({
          title: 'Pedido abaixo do valor mínimo',
          text: `O valor mínimo do pedido é R$ ${minimo.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} por causa do valor do frete — pedidos abaixo desse valor estão sujeitos à cobrança de frete. Deseja finalizar mesmo assim?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim, finalizar',
          cancelButtonText: 'Cancelar',
          confirmButtonColor: '#28a745',
          cancelButtonColor: '#6c757d',
          reverseButtons: true,
        });
        if (!confirmacao.isConfirmed) return;
      }

      // Perfil Cliente: um pedido tem UMA categoria só. Se algum item do
      // carrinho ficou com categoria diferente da do pedido atual (ex.: o
      // tipo de pedido foi trocado depois de adicionar itens), bloqueia.
      if (this.isPerfilCliente) {
        const tipoAtual = String(this.formInfoPedido.tipoPedidoCliente?.tipopedidoid || '').toUpperCase();
        const itens = this.$store.getters['PedidosStore/getItemPedido'] || [];
        const divergente = tipoAtual && itens.find(
          (i) => i.categoria_tipo_pedido && String(i.categoria_tipo_pedido).toUpperCase() !== tipoAtual,
        );
        if (divergente) {
          Swal.fire({
            icon: 'info',
            title: 'Categoria diferente',
            text: `O item "${divergente.item_descricao || divergente.item_id}" é da categoria ${nomeCategoria(divergente.categoria_tipo_pedido)}, `
              + `diferente da categoria deste pedido (${nomeCategoria(tipoAtual)}). `
              + 'Remova-o do carrinho e faça um novo pedido da categoria dele.',
          });
          return;
        }
      }

      // ID Nexus opcional em WD; quando preenchido, valida o formato.
      if (!(await this.garantirIdNexusCart())) return;

      this.loading = true;
      try {
        await this.recuperarPrecosTabelaCarrinho();
        const naturezaOperacaoImposto = this.pedidoItens.length > 0 && this.pedidoItens[0].naturezaoperacaoidimposto
          ? this.pedidoItens[0].naturezaoperacaoidimposto
          : this.formInfoPedido.naturezaOperacao?.naturezaoperacaoid || '';

        const dataEntregaISO = this.normalizeDateToISO(this.formInfoPedido.dataPrevistaEntrega || this.dataEntregaPadrao);

        let confirmarDivisaoCategorias = false;
        let resPedido = await this.enviarPedidoCart({ naturezaOperacaoImposto, dataEntregaISO, confirmarDivisaoCategorias });

        if (resPedido?.data?.precisaDividirCategorias || resPedido?.data?.dividido
          || !(resPedido?.data?.data?.pedidoid || resPedido?.data?.pedidoid)) {
          throw new Error('O servidor não confirmou um pedido único. Os itens foram preservados; consulte a lista antes de tentar novamente.');
        }

        // Se havia um rascunho ativo local, remove (pedido finalizado)
        const activeId = this.getActiveDraftId();
        if (activeId) {
          this.removeDraftCompletely(activeId);
        }

        // Aviso: integração com TOTVS pausada para testes
        const totvsFlag = await getParametro('INTEGRACAO_TOTVS');
        if (String(totvsFlag) === '0' && this.$toast) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Aviso',
              text: 'A integração com o TOTVS está pausada para período de testes.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
        }

        // Alerta de estouro de budget (modo ALERTAR): doação ultrapassou o saldo
        const alertaBudget = resPedido?.data?.alertaBudget;
        if (alertaBudget && this.$toast) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Atenção: budget estourado',
              text: alertaBudget,
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
        }

        // Pedido dividido por categoria: informa os dois números.
        const dividido = resPedido?.data?.dividido && Array.isArray(resPedido.data.pedidos);
        const htmlSucesso = dividido
          ? `Seu pedido foi dividido por categoria de budget:<br/>${resPedido.data.pedidos
            .map(p => `<strong>${p.categoria}</strong>: Pedido <strong>#${p.pedidoid}</strong>`)
            .join('<br/>')}`
          : `Seu pedido foi finalizado com sucesso! Número do Pedido: <strong>#${resPedido.data.data.pedidoid}</strong>`;

        Swal.fire({
          title: 'Pedido Finalizado com Sucesso!',
          html: htmlSucesso,
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          this.resetBoletoPara15Dias();
          this.$store.dispatch('PedidosStore/clearPedidoAndItemPedido');
          this.$router.push({ name: 'home' });
        });
      } catch (error) {
        console.error('Erro ao finalizar pedido:', error);

        const errorMessage = error.message;

        if (errorMessage === 'ERRO_PEDIDO_NR_OC_CLIENTE_EXISTE') {
          Swal.fire({
            title: 'Erro ao finalizar pedido',
            text: 'O número da ordem de compra já existe. Por favor, utilize um número diferente.',
            icon: 'warning',
            confirmButtonText: 'OK',
          });
          return;
        }
        // Mensagem clara vinda do backend (ex.: verba/budget insuficiente do
        // representante, ou perfil sem permissão para o tipo de pedido — 403).
        // O client de pedidos usa messageCustom, que extrai a mensagem do
        // backend para error.message (sem manter error.response). Também
        // cobrimos error.response.data.message para chamadas que repassam o erro cru.
        const backendMessage = error?.response?.data?.message || error?.message;
        if (backendMessage) {
          Swal.fire({
            title: (error && error.title) || 'Não foi possível finalizar o pedido',
            text: backendMessage,
            icon: 'warning',
            confirmButtonText: 'OK',
          });
          return;
        }
        Swal.fire({
          title: 'Erro ao finalizar pedido',
          text: 'Ocorreu um erro ao processar seu pedido. Por favor, tente novamente mais tarde.',
          icon: 'warning',
          confirmButtonText: 'OK',
        });
      } finally {
        this.loading = false;
      }
    },
    async handlerCancelarPedido() {
      Swal.fire({
        title: 'Cancelar Pedido',
        text: 'Deseja realmente cancelar o pedido?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
      }).then((result) => {
        if (result.isConfirmed) {
          this.resetBoletoPara15Dias();
          this.$store.dispatch('PedidosStore/clearPedidoAndItemPedido');
          this.$router.push({ name: 'home' });
        }
      });
    },
  },
  mounted() {
    try {
      console.debug('[Cart] Mounted: env', { NODE_ENV: process.env.NODE_ENV });
    } catch (e) { /* noop */ }

    // Perfil Cliente: garante dados completos (condição pgto/tabela/estabelecimento/
    // valor mínimo) sem exigir a abertura do modal Info Pedido.
    InitialDataService.ensureClienteFinalDataLoaded().catch(() => {});
    this.$store.dispatch('InfoPedido/garantirTipoPedidoDefault').catch(() => {});

    // Perfil Cliente NUNCA usa Doação (WD): higieniza carrinho persistido de
    // sessões antigas — itens marcados como WD viram Venda (WS) e uma seleção
    // WD é trocada pelo padrão (o mutation SET_TIPO_PEDIDO_CLIENTE corrige).
    if (this.isPerfilCliente) {
      const pedidoAtual = this.$store.state.PedidosStore.pedido || {};
      const itensAtuais = pedidoAtual.pedidoItens || [];
      if (itensAtuais.some((i) => String(i.categoria_tipo_pedido || '').toUpperCase() === 'WD')) {
        this.$store.commit('PedidosStore/SET_PEDIDO', {
          ...pedidoAtual,
          pedidoItens: itensAtuais.map((i) => (
            String(i.categoria_tipo_pedido || '').toUpperCase() === 'WD'
              ? { ...i, categoria_tipo_pedido: 'WS' }
              : i)),
        });
      }
      const tipoSel = this.formInfoPedido?.tipoPedidoCliente;
      if (tipoSel && String(tipoSel.tipopedidoid || '').toUpperCase() === 'WD') {
        this.$store.commit('InfoPedido/SET_TIPO_PEDIDO_CLIENTE', tipoSel);
      }
    }
    this.$store.dispatch('preferencias/load').catch(() => {});

    if (this.getTotalItensPedido === 0) {
      this.$router.push({ name: 'home' });
    }

    // Garante que condicaoPagamento seja sempre um objeto (evita erro no v-model
    // dos campos aninhados após restaurações parciais de localStorage/rascunho)
    if (!this.formInfoPedido.condicaoPagamento) {
      this.$store.commit('InfoPedido/SET_CONDICAO_PAGAMENTO_FORM', {
        condicaopagamentoid: null,
        condicaopagamentodescricao: null,
      });
    }

    if (!this.formInfoPedido.dataPrevistaEntrega) {
      console.debug('[Cart] No dataPrevistaEntrega found, committing default', { defaultBR: this.dataEntregaPadrao });
      this.$store.commit('InfoPedido/SET_DATA_PREVISTA_ENTREGA', this.dataEntregaPadrao);
    } else {
      console.debug('[Cart] Existing dataPrevistaEntrega', { value: this.formInfoPedido.dataPrevistaEntrega });
      this.ensureValidEntregaDateBR();
    }

    try {
      const activeId = this.getActiveDraftId();
      const draftsIndex = localStorage.getItem('pedido_drafts_index');
      console.debug('[Cart] Cache snapshot', { activeDraftId: activeId, draftsIndexLen: draftsIndex ? draftsIndex.length : 0 });
    } catch (e) { /* noop */ }

    // Tenta restaurar rascunho ativo (se existir) quando entrar no carrinho
    this.loadActiveDraftIfAny();

    // Aviso antecipado de budget (doação WD) já na abertura do carrinho.
    this.agendarChecagemBudget();
  },
  beforeDestroy() {
    this.budgetCheckSeq += 1;
    if (this.budgetCheckTimer) clearTimeout(this.budgetCheckTimer);
    this.resetBoletoPara15Dias();
  },
};
</script>

<template>
  <b-overlay :show="loading" rounded="sm">
    <template #overlay>
      <div class="text-center">
        <b-spinner small class="mr-1"></b-spinner>
        <strong>
          Processando Pedido...
        </strong>
      </div>
    </template>
    <b-row class="position-relative">
      <b-col cols="12">
        <h1 class="cart-title">Carrinho</h1>
      </b-col>
      <!-- Aviso ANTECIPADO de budget (doação WD): estouro por categoria ELT/GL -->
      <b-col v-if="isPedidoDoacaoAtual && avisosBudgetCarrinho.length" cols="12">
        <b-alert show :variant="budgetCarrinhoBloqueia ? 'danger' : 'warning'" class="mb-1">
          <div class="p-50">
            <feather-icon icon="AlertTriangleIcon" class="mr-50" />
            <strong>{{ budgetCarrinhoBloqueia ? 'Budget insuficiente' : 'Atenção ao budget' }}</strong>
            <div v-for="(msg, i) in avisosBudgetCarrinho" :key="`bw-${i}`" class="small mt-25">{{ msg }}</div>
            <div v-if="budgetMisto" class="small mt-25">
              Pedido único com itens ELT e GL. Cada supervisor aprova somente sua categoria; o envio ao Datasul aguarda as duas aprovações.
            </div>
          </div>
        </b-alert>
      </b-col>
      <b-col cols="12" md="8">
        <b-row>
          <b-col v-for="(item, index) in items" :key="`item-${item.item_id}-${index}`" cols="12"
            style="overflow-y: auto">
            <card-item-new :item="item" />
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="4">
        <b-card style="position: sticky;top: 70px;">
          <template #header>
            <h4 class="card-title">Resumo do Pedido</h4>
          </template>
          <!-- Tipo de Pedido: perfil Cliente NÃO vê seletor (primeiro item define a
               categoria; mistura é bloqueada na adição). Demais perfis podem ver
               quando o getter de opções estiver populado. -->
          <b-form-group
            v-if="!isPerfilCliente && $store.getters['InfoPedido/GET_OPTIONS_TIPO_PEDIDO_CLIENTE'] && $store.getters['InfoPedido/GET_OPTIONS_TIPO_PEDIDO_CLIENTE'].length > 0"
            label="Tipo de Pedido" label-for="tipoPedido">
            <v-select id="tipoPedido" v-model="formInfoPedido.tipoPedidoCliente"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :clearable="false" label="tipopedidodescricao"
              :disabled="true" :options="$store.getters['InfoPedido/SET_TIPO_PEDIDO_CLIENTE']"
              @input="onInputTipoPedidoCliente" :reduce="option => option">
              <template #selected-option="{ tipopedidoid, tipopedidodescricao }">
                <div style="display: flex; align-items: baseline">
                  <strong>{{ tipopedidoid }} - {{ tipopedidodescricao }}</strong>
                </div>
              </template>
              <template #option="{ tipopedidoid, tipopedidodescricao }">
                <div class="d-flex align-items-center">
                  <span> {{ tipopedidoid }} - {{ tipopedidodescricao }}</span>
                </div>
              </template>
            </v-select>
          </b-form-group>
          <b-form-group v-if="$store.getters['preferencias/condicaoPagamentoAtiva'] && !ocultarTabelaCondicao && !isPedidoDoacaoAtual" label="Condição de Pagamento" label-for="condicaoPagamentoId">
            <b-input-group>
              <b-form-input
                id="condicaoPagamentoId"
                placeholder="Código"
                v-model="formInfoPedido.condicaoPagamento.condicaopagamentoid"
                type="number"
                @keypress="onlyNumber($event)"
                @keyup.enter="onChangeCondPagto"
                @blur="onChangeCondPagto"
              />
              <b-input-group-append>
                <b-button
                  variant="primary"
                  v-b-modal.modal-buscar-condpgto-info-pedido
                  v-b-tooltip.hover
                  title="Abrir lista de condições de pagamento"
                >
                  <feather-icon icon="SearchIcon" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-form-group v-if="$store.getters['preferencias/condicaoPagamentoAtiva'] && !ocultarTabelaCondicao && !isPedidoDoacaoAtual" label="Descrição Condição de Pagamento" label-for="condicaoPagamentoDescricao">
            <b-form-input
              id="condicaoPagamentoDescricao"
              disabled
              v-model="formInfoPedido.condicaoPagamento.condicaopagamentodescricao"
            />
          </b-form-group>
          <b-form-checkbox v-if="exibirBoletoPara15Dias" v-model="boletoPara15Dias" :disabled="pagamentoAVistaSelecionado" class="mb-1">
            Boleto para 15 dias
          </b-form-checkbox>
          <pagamento-a-vista-visual
            v-if="exibirBoletoPara15Dias"
            ref="pagamentoAVistaVisual"
            :disabled="boletoPara15Dias"
            @change="pagamentoAVistaSelecionado = $event"
            :total="Number($store.getters['PedidosStore/getTotalPedidoComImposto'])"
            :valor-minimo="Number((GET_CLIENTE_DATA || {}).valorMinimoPedido || 0)"
          />
          <modal-buscar-cond-pagamento />
          <modal-auto-completar-pedido ref="modalAutoCompletar" contexto="home" />
          <!-- Endereço de entrega alternativo (mesma UF; busca por CEP) -->
          <b-form-group v-if="isPedidoDoacaoAtual" label="Endereço de Entrega" label-for="enderecoEntregaAlt">
            <escolher-endereco-entrega
              v-model="enderecoAlternativo"
              :clienteid="formInfoPedido.cliente.clienteid"
              :uf-atual="String(formInfoPedido.enderecoEntrega && formInfoPedido.enderecoEntrega.ufid || '').trim()"
            />
          </b-form-group>
          <!-- Transporte é uma informação opcional exclusiva de doação (WD). -->
          <select-transporte v-if="isPedidoDoacaoAtual" v-model="transporteId" />
          <!-- Perfil Cliente não define data de entrega: campo oculto (antes era só desabilitado) -->
          <b-form-group v-if="!isPerfilCliente && $store.getters['preferencias/exibirDataPrevistaEntrega'] !== false" label="Data Prevista de Entrega" label-for="dataPrevistaEntrega">
            <b-form-input
              id="dataPrevistaEntrega"
              type="date"
              v-model="dataEntregaInput"
              :min="todayISO"
            />
          </b-form-group>
          <b-card-text class="pt-1">
            <!-- <div class="d-flex justify-content-between">
            <span class="text-subtitle1 font-weight-bold">Total:</span>
            <span style="color: #3b5998;font-weight: bold">{{ $store.getters['PedidosStore/getTotalPedido'] | formtPriceBr }}</span>
          </div> -->
            <div class="d-flex justify-content-between">
              <span class="text-subtitle1 font-weight-bold">{{ totalDeCustoVisual ? 'Total (valor de custo):' : 'Total final:' }}</span>
              <span v-if="totalVisual !== null" style="color: #3b5998;font-weight: bold">{{ totalVisual | formtPriceBr }}</span>
              <span v-else style="color: #3b5998;font-weight: bold">—</span>
            </div>
          </b-card-text>
          <div class="">
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="success"
                class="w-100"
                block
                @click="finalizarPedidoCart"
                :disabled="bloqueioPedidoMinimoAtivo && !pedidoMinimo"
            >
              <feather-icon icon="CheckCircleIcon" size="18" style="margin-right: 0.5rem;"/>
              Finalizar Compra
            </b-button>
             <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="danger"
                class="w-100"
                block
                @click="handlerCancelarPedido"
            >
              <feather-icon icon="XCircleIcon" size="18" style="margin-right: 0.5rem;"/>
              Cancelar Pedido
            </b-button>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="warning"
                class="w-100"
                block
                :to="{ name: 'home' }"
            >
              <feather-icon icon="ShoppingCartIcon" size="18" style="margin-right: 0.5rem;"/>
              Continuar Comprando
            </b-button>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                class="w-100"
                block
                @click="abrirAutoCompletar"
            >
              <feather-icon icon="RepeatIcon" size="18" style="margin-right: 0.5rem;"/>
              Auto completar pedido
            </b-button>
            <b-button
                v-if="rascunhoDisponivel"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="secondary"
                class="w-100"
                block
                @click="finalizarRascunhoCart"
            >
              <feather-icon icon="FileTextIcon" size="18" style="margin-right: 0.5rem;"/>
              Salvar Como Rascunho
            </b-button>
            <b-alert v-if="!isPedidoDoacaoAtual" variant="warning" :show="!pedidoMinimo" class="mt-2">
              <div class="alert-body">
                <span>Pedido mínimo: R${{ (GET_CLIENTE_DATA || {}).valorMinimoPedido || 0 }} — abaixo desse valor há cobrança de frete</span>
              </div>
            </b-alert>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<style scoped lang="scss">
.cart-title {
  color: var(--sf-surface-text-dark) !important;
}

// Sidebar card respects theme
.b-card {
  background: var(--sf-card-bg) !important;
  color: var(--sf-card-text) !important;
  border-color: var(--sf-card-border) !important;
}

// Form groups / inputs inside the sticky card
.form-group label {
  color: var(--sf-surface-muted) !important;
}

.form-control {
  background: var(--sf-form-bg) !important;
  color: var(--sf-form-text) !important;
  border-color: var(--sf-form-border) !important;
}
</style>
